const BRAND = "U LOVE U";

export function ULoveULogo({ className = "" }) {
  return (
    <span role="img" aria-label={BRAND} className={`whitespace-nowrap ${className}`} data-testid="ulove-logo">
      U L
      <svg viewBox="0 0 24 22" aria-hidden="true" className="mx-[0.04em] inline-block"
        style={{ height: "0.72em", width: "0.79em", verticalAlign: "baseline" }}>
        <path fill="#E53935" d="M12 21.6 10.3 20C4.1 14.4 0 10.7 0 6.2 0 2.7 2.7 0 6.2 0c2 0 3.9.9 5.1 2.4h1.4C13.9.9 15.8 0 17.8 0 21.3 0 24 2.7 24 6.2c0 4.5-4.1 8.2-10.3 13.8L12 21.6Z" />
      </svg>
      VE U
    </span>
  );
}

// Renders text, swapping every "U LOVE U" for the heart logo.
export function BrandText({ text }) {
  if (typeof text !== "string" || !text.includes(BRAND)) return text;
  return text.split(BRAND).flatMap((part, i) => (i === 0 ? [part] : [<ULoveULogo key={i} />, part]));
}
